import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Login from './../pages/login'
import Dashboard from './../pages/dashboard'
import Order from './../pages/order'
import User from './../pages/user'
import UserDetail from './../pages/user/user-detail/'

const RouteConfig = (
  <Router>
    <div>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/orders" component={Order} />
        <Route path="/orders/:page" component={Order} />
        <Route path="/users" component={User} />
        <Route path="/user-detail/:userId" component={UserDetail} />
      </Switch>
    </div>
  </Router>
)

export default RouteConfig



// WEBPACK FOOTER //
// src/router/index.js